import {
  SofturaTable,
  Label,
  Row,
  Col,
  InputField,
  SwitchToggle,
  PrimaryButton,
  OutlineButton,
  PopupDialogbox
} from "../../../../../CommonComponents";
import "../AppRoles.scss";
import { Dropdown } from "@fluentui/react/lib/Dropdown";
import useAddEditRole from "../hooks/useAddEditRole";
import { useSelector } from "react-redux";

const EditRoles = (props: any) => {
  const {
    selectAllHandler,
    roleFormData,
    onChangeHandler,
    handleSubmit,
    appChangeHandler,
    applications,
    permissionChangeHandler,
    formError,
    isPermissionSelect,
    selectall,
    Popupcontent
  } = useAddEditRole(props);
  const { addedRoleVal, checkRole } = useSelector((state: any) => ({
    addedRoleVal: state.AppRole.addedRoleVal,
    checkRole: state.AppRole.checkRole
  }));

  const columns = [
    {
      key: "applicationName",
      title: "Application",
      width: 200,
    },
    {
      key: "appAreaName",
      title: "App Area",
      width: 200,
    },
    {
      key: "permissionName",
      title: "Permission Name",
      width: 200,
    },
    {
      key: "permissionDescription",
      title: "Permission Description",
      width: 200,
    },
    {
      key: "roleSelect",
      title: "Select",
      width: 100,
      Cell: (row: any) => {
        return (
          <SwitchToggle
            className="mb-3"
            key={row?.rowData?.id}
            checked={row?.rowData?.isSelected}
            disabled={true}
            onChange={(event: any, value: boolean) =>
              permissionChangeHandler(row?.rowData, value)
            }
           data-attribute="AddEditRole_Default_SwitchToggle" />
        );
      },
    },
  ];

  return (
    <div className="app-grid-container">
      <div className="app-roles-head">
        <Row>
          <Col xs={12} sm={12} md={3} lg={3} xl={3} className="mb-3">
            <Label required data-attribute="AddEditRole_Default_Label">Application</Label>
            <Dropdown
              placeholder="Select options"
              multiSelect
              selectedKeys={applications?.filter((item: any) => item?.selected).map((item: any) => item.key)}
              key={'role-applications'}
              options={applications}
              disabled={true}
              onChange={(event, value) => {
                appChangeHandler(event, value, "applications");
              }}
             data-attribute="AddEditRole_Default_Dropdown" />
            {formError?.applicationsError ? (
              <span className="asset-validation-msg">
                {formError?.applicationsError}
              </span>
            ) : null}
          </Col>
          <Col xs={12} sm={12} md={3} lg={3} xl={3} className="mb-3">
            <Label required data-attribute="AddEditRole_Default_Label_2">Role Name</Label>
            <InputField
              name="roleName"
              value={roleFormData?.roleName}
              onChange={onChangeHandler}
              disabled={true}
             data-attribute="AddEditRole_roleName_Input" />
            {formError?.roleNameError ? (
              <span className="asset-validation-msg">
                {formError?.roleNameError}
              </span>
            ) : null}
          </Col>
          <Col xs={12} sm={12} md={3} lg={3} xl={3} className="mb-3">
            <Label required data-attribute="AddEditRole_Default_Label_3">Role Description</Label>
            <InputField
              name="roleDescription"
              value={roleFormData?.roleDescription}
              onChange={onChangeHandler}
              disabled={true}
             data-attribute="AddEditRole_roleDescription_Input" />
            {formError?.roleDescriptionError ? (
              <span className="asset-validation-msg">
                {formError?.roleDescriptionError}
              </span>
            ) : null}
          </Col>
          <Col xs={12} sm={12} md={3} lg={3} xl={3} className="mb-3">
            <Label data-attribute="AddEditRole_Default_Label_4">Select All</Label>
            <SwitchToggle disabled={true} onChange={selectAllHandler} checked={selectall} className="mb-3"  data-attribute="AddEditRole_Default_SwitchToggle_2" />
          </Col>
        </Row>
      </div>
      <div
        className={
          roleFormData?.permissions?.length !== 0
            ? "softura-table"
            : "softura-table paginationNav"
        }
      >
        <SofturaTable
          data={roleFormData?.permissions}
          columns={columns}
          sort={true}
          defaultPageSize={10}
          pageSizes={[10, 20, 50]}
          globalSearch={false}
          filter={true}
         data-attribute="AddEditRole_Default_Grid" />
      </div>
      <Row>
        <Col className="pull-right mt-3">
          <PrimaryButton
            text="Save"
            className="pull-right "
            onClick={handleSubmit}
            disabled={true}
           data-attribute="AddEditRole_Default_Button" />
          <OutlineButton text="Cancel" disabled={true} className="pull-right me-1"  data-attribute="AddEditRole_Default_Button_2" />
        </Col>
      </Row>
      {(!isPermissionSelect || addedRoleVal > 0 || checkRole || addedRoleVal == "error") ? (
        <PopupDialogbox
        hideDialog={!Popupcontent.isDialogVisible}
        onDismiss={() => Popupcontent?.popupOutlinebtnOnclick()}
        Popupcontent={Popupcontent}
        popupOutlinebtnOnclick={() => Popupcontent?.popupOutlinebtnOnclick()}
        popupPrimarybtnOnclick={(
          item: any,
          actionby: string,
          value: any) => Popupcontent?.popupPrimarybtnOnclick(item,
            actionby,
            value)}
       data-attribute="AddEditRole_Default_PopupDilalogBox" />
      ) : null}
    </div>
  );
};
export default EditRoles;
